import { AppBar, Box, makeStyles, Tab, Tabs, Theme } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import DenseAppBar from '../../components/AppBar';
import Banner from '../../components/Banner';
import CashoutAccount from '../../components/CashoutAccount';
import ChangePassword from '../../components/ChangePassword';
import ChangePIN from '../../components/ChangePIN';
import CreatePin from '../../components/CreatePin';
import SalesRep from '../../components/SalesRep';
import { Reducers } from '../../Interfaces/Interfaces';
import { getAdminUser, getCoordinatorCashoutAccount, getCurrentUser } from '../../redux/actions/CoordinatorActions';
import { getAggregatorDetails, getAggregatorAdminUser, getCashoutAccount, getUserDetails } from '../../redux/actions/userActions';
import PrimaryTheme from '../../Themes/Primary';
import "./settings.scss"
import WalletWithdrawal from '../../components/WalletWithdrawal';
interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={2}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function Settings(props:any) {
  const alert = useSelector((state: Reducers) => state.alert);
  const user = useSelector((state: Reducers) => state.user);
  const userType = useSelector((state: Reducers) => state.userType);
  const cashout = useSelector((state: Reducers) => state.cashout);
  const tokens = useSelector((state: Reducers) => state.tokens);

  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  // const [] = React.useState('');

  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [hasCashoutAccount, setCashoutAccount] = React.useState(false);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  React.useEffect(() => {
    if (cashout && cashout.hasCashoutAccount && Object.entries(cashout).length !== 0) {
      setCashoutAccount(true)
    } else {
      setCashoutAccount(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cashout]);


  React.useEffect(() => {

    if (userType === '5') {
      dispatch(getUserDetails(user.phoneNumber));
      dispatch(getCashoutAccount(user.id));
      dispatch(getAggregatorDetails(user.id));

     
    }
    else if (userType === '9') {
      dispatch(getAggregatorAdminUser());
      dispatch(getCashoutAccount(user.id));
      //dispatch(getAggregatorDetails(user.id));

     
    }
    else if (userType === '8') {
      // dispatch(getAdminUser(tokens.access_token));
      // dispatch(getCoordinatorCashoutAccount(user.id));

     
    }
    else {
     
      // dispatch(getUserDetails(user.phoneNumber));
      // dispatch(getCashoutAccount(user.id));
      // dispatch(getAggregatorDetails(user.id));
    }

    // dispatch({
    //   type: 'LOADING',
    //   payload: true
    // });

    // return () => {
    //   dispatch({
    //     type: 'CASHOUT',
    //     payload: {}
    //   });
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);


  React.useEffect(() => {
    if (Object.entries(alert).length !== 0) {
      if (!alert.successful) {
        // display error message
        enqueueSnackbar(alert.message, { variant: "error" });

        dispatch({
          type: 'LOADING',
          payload: false
        })

        dispatch({
          type: 'ALERT',
          payload: {}
        });

      } else {

        if (alert.message === "OTP sent") {
          history.push("/update-pin")
        }

        // enqueueSnackbar(alert.message, { variant: "success" });

        // handleRefresh();

        // dispatch({
        //   type: 'LOADING',
        //   payload: false
        // })

        // dispatch({
        //   type: 'ALERT',
        //   payload: {}
        // });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, enqueueSnackbar, alert, history]);

  return (
    <React.Fragment>
      <div className="col-md-11 mr-auto ml-auto p-0" style={{
        height: 'auto',
        position: "relative",
      
      }}>
        <DenseAppBar />
      </div>
      <div className='col-md-12 pl-0 pr-0' style={{
        // overflow: "auto",
        backgroundColor: PrimaryTheme.white,
      
        // height: '100vh',
      }}>

        <div className="col-md-11 ml-auto mr-auto p-0" style={{
          backgroundColor: PrimaryTheme.white,
          height: '100vh',
          position: 'relative',
         
        }}>
          <h1 className="mb-5 settings-title" style={{
            fontFamily: PrimaryTheme.fonts?.MediumFont,
            textTransform: "uppercase",
            fontSize: PrimaryTheme.fontSizes?.subtitle
          }}>{"Settings & Support"}</h1>


          <div className="row mb-5">
            <div className="col-md-12">
              <div className={classes.root} >
                <AppBar position="static" color="transparent" elevation={0} >

                  <Tabs value={value} onChange={handleChange} aria-label="simple tabs example" >
                    {/* <Tab label="Update Profile" {...a11yProps(0)} /> */}

                    <Tab label="Change Password" {...a11yProps(0)} />
                    <Tab label={user.isTransactionPinSet ? "Change Transaction PIN" : "Create Transaction PIN"} {...a11yProps(1)} />
                    {/* <Tab label={hasCashoutAccount ? "Cashout Account" : "Setup Cashout Account"} {...a11yProps(2)} /> */}
                    <Tab label={"Withdrawal account"} {...a11yProps(2)} />
                    {userType === "5" && <Tab label="Sales Rep" {...a11yProps(3)} />}

                  </Tabs>

                </AppBar>

                {/* <TabPanel value={value} index={0}>
                  Update Profile
                </TabPanel> */}

                <TabPanel value={value} index={0} >
                  <div className="col-md-6 ml-auto mr-auto" style={{paddingBottom:"50px"}}>
                    <Banner
                      className="bq-warning"
                      text={"Use a minimum of 6 characters, upper and lowercase letters, numbers and symbols."}
                      iconColor={PrimaryTheme.dark}
                    />
                    <ChangePassword />
                  </div>
                </TabPanel>

                <TabPanel value={value} index={1}>
                  <div className="col-md-6 ml-auto mr-auto" style={{paddingBottom:"50px"}}>
                    <Banner
                      className="bq-warning"
                      text={user.isTransactionPinSet ? "Update transaction PIN" : "Create Transaction PIN"}
                      iconColor={PrimaryTheme.dark}
                    />
                    {user.isTransactionPinSet ? <ChangePIN /> : <CreatePin />}
                  </div>
                </TabPanel>

                {/* <TabPanel value={value} index={2}>
                  <div className="col-md-6 ml-auto mr-auto" style={{paddingBottom:"50px"}}>
                    <CashoutAccount />
                  </div>
                </TabPanel> */}
                <TabPanel value={value} index={2}>
                  <div className="col-md-6 ml-auto mr-auto" style={{paddingBottom:"50px"}}>
                    <h5 className="mb-3 text-bold">Wallet withdrawal account</h5>
                    {!hasCashoutAccount && <Banner
                      className="bq-warning2"
                      text={"Setup your withdrawal account where your funds withdrawn will be deposited. This must be a Bankly MFB account."}
                      iconColor={PrimaryTheme.dark}
                      isWalletWithdrawal
                    />}
                    <WalletWithdrawal />
                  </div>
                </TabPanel>

                {userType === "5" && <TabPanel value={value} index={3}>
                  <div className="col-md-12 ml-auto mr-auto" style={{paddingBottom:"50px"}}>
                    <SalesRep />
                  </div>
                </TabPanel>
                }

              </div>
            </div>
          </div>
        </div>

      </div>
    </React.Fragment>
  )
}
